module.exports = __webpack_public_path__ + "images/tft-trigger-banner-mobile-bg.webp";